/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum TravelCalculationMode {
    PerKilometer = 1,
    PerHour = 2,
}
